import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  fetchSensorAverageDataStart,
  removeSensorAverageData,
  resetSensorAverageData,
} from "../store/features/customer/sensor/sensorAverageDataSlice";

export const useSensorAverageDataFetch = ({
  measures, fieldId, accessToken, timeRange, enabled, scope, source = "sensors",
}) => {
  const dispatch = useDispatch();
  const requestedMeasures = useRef(new Set());
  const { from, to } = timeRange;
  const measuresKey = JSON.stringify([...new Set(measures)].sort());

  useEffect(() => {
    requestedMeasures.current = new Set();
    return () => dispatch(resetSensorAverageData(scope ? { scope } : undefined));
  }, [dispatch, scope, source, accessToken, fieldId, from, to, enabled]);

  useEffect(() => {
    if (!enabled || !accessToken || !fieldId) return;

    const selection = new Set(JSON.parse(measuresKey));
    requestedMeasures.current.forEach((measure) => {
      if (!selection.has(measure)) {
        dispatch(removeSensorAverageData({ measure, ...(scope ? { scope } : {}) }));
      }
    });
    selection.forEach((measure) => {
      if (!requestedMeasures.current.has(measure)) {
        dispatch(fetchSensorAverageDataStart({
          accessToken, fieldId, measure, from, to, source,
          ...(scope ? { scope } : {}),
        }));
      }
    });
    requestedMeasures.current = selection;
  }, [dispatch, measuresKey, scope, source, accessToken, fieldId, from, to, enabled]);
};
